// import React, { useState, useEffect } from "react";
// import {
//   ArrowRight,
//   Play,
//   Users,
//   Star,
//   CheckCircle,
//   Award,
//   Target,
// } from "lucide-react";
// import { motion } from "framer-motion";
// import banner from "./HERO2.png";
// import heor from "./heor1.jfif";

// const ArchitectHero = () => {
//   const [imagesLoaded, setImagesLoaded] = useState({
//     banner: false,
//     heor: false,
//   });
  
//   // Preload critical image (hero image) immediately
//   useEffect(() => {
//     const preloadImage = (src, key) => {
//       const img = new Image();
//       img.src = src;
//       img.onload = () => {
//         setImagesLoaded(prev => ({ ...prev, [key]: true }));
//       };
//       img.onerror = () => {
//         console.warn(`Failed to load image: ${src}`);
//         setImagesLoaded(prev => ({ ...prev, [key]: false }));
//       };
//     };

//     // Preload hero image first as it's more critical
//     if (heor) preloadImage(heor, 'heor');
//     // Then preload banner
//     if (banner) preloadImage(banner, 'banner');
//   }, []);

//   return (
//     <div className="relative">
//       <section className="bg-gradient-to-br from-slate-100 to-emerald-100 relative min-h-screen flex items-center overflow-hidden">
//         {/* Background Pattern */}
//         <div className="absolute inset-0 pointer-events-none">
//           <motion.div
//             className="absolute top-20 left-10 w-64 h-64 rounded-full bg-gradient-to-br from-emerald-400 to-cyan-500 opacity-40 blur-3xl mix-blend-multiply"
//             animate={{
//               y: [0, -20, 0],
//               x: [0, 10, 0],
//             }}
//             transition={{
//               duration: 8,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           />
//           <motion.div
//             className="absolute bottom-20 right-10 w-96 h-96 rounded-full bg-gradient-to-tr from-yellow-300 to-emerald-500 opacity-30 blur-3xl mix-blend-multiply"
//             animate={{
//               y: [0, 30, 0],
//               x: [0, -15, 0],
//             }}
//             transition={{
//               duration: 10,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           />
//           <motion.div
//             className="absolute top-1/2 right-1/3 w-80 h-80 rounded-full bg-gradient-to-r from-violet-400 to-fuchsia-500 opacity-35 blur-3xl mix-blend-multiply"
//             animate={{
//               y: [0, -25, 0],
//               scale: [1, 1.05, 1],
//             }}
//             transition={{
//               duration: 9,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           />
//         </div>

//         {/* Main Content */}
//         <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
//   <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//     {/* Colonne de gauche - Contenu texte */}
//     <motion.div
//       className="relative lg:h-[500px]"
//       initial={{ opacity: 0, y: 30 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.8, ease: "easeOut" }}
//     >
//       {/* Titre */}
//       <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-12">
//         <motion.span
//           className="text-gray-900 block"
//           initial={{ opacity: 0, scale: 0.95 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.6, delay: 0.1 }}
//         >
//           Maîtrisez le 
//         </motion.span>
//         <motion.span
//           className="relative text-emerald-600 block"
//           initial={{ opacity: 0, x: -20 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7, delay: 0.3 }}
//         >
//           Design Architectural
//           <svg
//             className="absolute -bottom-2 left-0 w-32 h-1 text-emerald-400"
//             fill="currentColor"
//           >
//             <rect width="100%" height="100%" rx="0.5" />
//           </svg>
//         </motion.span>
//       </h1>

//       {/* Description */}
//       <motion.p
//         className="text-md text-gray-600 mb-8 leading-relaxed max-w-2xl"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.7, delay: 0.4 }}
//       >
//         Rejoignez des architectes en herbe dans un parcours transformateur. Notre programme pratique combine des principes de design innovants avec des compétences concrètes, vous préparant à une carrière réussie.
//       </motion.p>

//       {/* Boutons CTA */}
//       <motion.div
//         className="flex flex-col sm:flex-row gap-4"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.7, delay: 0.5 }}
//       >
//         <button className="group relative bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-semibold px-8 py-4 rounded-xl flex items-center justify-center gap-3 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 shadow-lg shadow-emerald-600/20 hover:scale-105">
//           <span>Découvrir les formations</span>
//           <ArrowRight
//             className="group-hover:translate-x-1 transition-transform"
//             size={20}
//           />
//         </button>

//         <button className="group bg-white hover:bg-gray-50 text-gray-900 font-semibold px-8 py-4 rounded-xl border border-gray-300 flex items-center justify-center gap-3 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:scale-105">
//           <div className="p-2 bg-gray-100 rounded-lg group-hover:bg-gray-200 transition-colors">
//             <Play size={18} className="text-gray-700" />
//           </div>
//           <span>consultation gratuite</span>
//         </button>
//       </motion.div>
//     </motion.div>

//     {/* Colonne de droite - Visuel */}
//     <motion.div
//       className="relative lg:h-[600px]"
//       initial={{ opacity: 0, x: 30 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.9, delay: 0.2 }}
//     >
//       <div className="relative h-full">
//         {/* Image principale - Étudiants en studio d'architecture */}
//         <motion.div
//           className="relative rounded-3xl overflow-hidden shadow-2xl h-[400px] lg:h-[500px] mb-6"
//           initial={{ opacity: 0, scale: 0.9 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 1, delay: 0.6 }}
//           whileHover={{ scale: 1.02 }}
//         >
//           {/* Image avec fallback */}
//           <div className="w-full h-full">
//             {heor && (
//               <img
//                 src={heor}
//                 alt="Étudiants en architecture travaillant en studio"
//                 className={`w-full h-full object-cover transition-opacity duration-500 ${
//                   imagesLoaded.heor ? 'opacity-100' : 'opacity-100'
//                 }`}
//                 loading="eager"
//                 onLoad={() => setImagesLoaded(prev => ({ ...prev, heor: true }))}
//               />
//             )}
//           </div>
          
//           {/* Overlay toujours visible */}
//           <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>

//           {/* Contenu overlay */}
//           <motion.div
//             className="absolute bottom-6 left-6 right-6"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7, delay: 0.8 }}
//           >
//             <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 max-w-xs">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
//                   <Target className="text-emerald-600" size={20} />
//                 </div>
//                 <div>
//                   <p className="font-bold text-gray-900">
//                     Session Studio en Direct
//                   </p>
//                   <p className="text-sm text-gray-600">
//                     Étudiants collaborant sur des designs
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         </motion.div>

//         {/* Éléments décoratifs de plans */}
//         <div className="hidden lg:block absolute -left-12 top-1/2 transform -translate-y-1/2">
//           <div className="relative">
//             <motion.div
//               className="w-24 h-1 bg-emerald-300 rounded-full rotate-45 mb-4"
//               animate={{ opacity: [0.5, 1, 0.5] }}
//               transition={{ duration: 2, repeat: Infinity }}
//             />
//             <motion.div
//               className="w-16 h-1 bg-emerald-200 rounded-full rotate-45"
//               animate={{ opacity: [0.5, 1, 0.5] }}
//               transition={{ duration: 2, delay: 0.5, repeat: Infinity }}
//             />
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   </div>
// </div>
 
//       </section>

//       {/* Statistics Banner - Adjusted to appear a bit later */}
//       <motion.div
//         className="relative -mt-40 z-20"
//         initial={{ opacity: 0, y: 40, scale: 0.98 }}
//         whileInView={{ opacity: 1, y: 0, scale: 1 }}
//         viewport={{ once: true, amount: 0.3 }}
//         transition={{ duration: 0.9, ease: "easeOut" }}
//       >
//         <div>
//           <div className="relative overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500">
//             {/* Background with loading fallback */}
//             <div className="absolute inset-0">
//               <div className="w-full h-full bg-gradient-to-r from-emerald-900 to-slate-900">
//                 {banner && (
//                   <img
//                     src={banner}
//                     alt="Architecture students achievement"
//                     className={`w-full h-full object-cover scale-110 hover:scale-100 transition-all duration-700 ${
//                       imagesLoaded.banner ? 'opacity-100' : 'opacity-0'
//                     }`}
//                     loading="lazy"
//                     onLoad={() => setImagesLoaded(prev => ({ ...prev, banner: true }))}
//                   />
//                 )}
//               </div>
//               <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/90 via-emerald-900/85 to-slate-900/80 mix-blend-multiply hover:opacity-95 transition-opacity duration-500"></div>
//             </div>

//             {/* Statistics Content - Shows immediately */}
//             <div className="relative z-10 py-12 px-6 lg:py-20 lg:px-16">
//               <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
//                 <motion.div
//                   className="text-center transform hover:scale-105 transition-transform duration-300"
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.6, delay: 0.1 }}
//                 >
//                   <div className="flex items-center justify-center gap-2 mb-3">
//                     <Users className="text-emerald-300" size={28} />
//                     <span className="text-4xl lg:text-5xl font-bold text-white">
//                       25+
//                     </span>
//                   </div>
//                   <p className="text-emerald-100 font-medium text-lg">
//                     Étudiants formés
//                   </p>
//                 </motion.div>

//                 <motion.div
//                   className="text-center transform hover:scale-105 transition-transform duration-300"
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.6, delay: 0.2 }}
//                 >
//                   <div className="flex items-center justify-center gap-2 mb-3">
//                     <Award className="text-emerald-300" size={28} />
//                     <span className="text-4xl lg:text-5xl font-bold text-white">
//                       3
//                     </span>
//                   </div>
//                   <p className="text-emerald-100 font-medium text-lg">
//                     Années d'expérience
//                   </p>
//                 </motion.div>

//                 <motion.div
//                   className="text-center transform hover:scale-105 transition-transform duration-300"
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.6, delay: 0.3 }}
//                 >
//                   <div className="flex items-center justify-center gap-2 mb-3">
//                     <Star className="text-emerald-300" size={28} />
//                     <span className="text-4xl lg:text-5xl font-bold text-white">
//                       4.9
//                     </span>
//                   </div>
//                   <p className="text-emerald-100 font-medium text-lg">
//                     Average Rating
//                   </p>
//                 </motion.div>

//                 <motion.div
//                   className="text-center transform hover:scale-105 transition-transform duration-300"
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.6, delay: 0.4 }}
//                 >
//                   <div className="flex items-center justify-center gap-2 mb-3">
//                     <CheckCircle className="text-emerald-300" size={28} />
//                     <span className="text-4xl lg:text-5xl font-bold text-white">
//                       15+
//                     </span>
//                   </div>
//                   <p className="text-emerald-100 font-medium text-lg">
//                     Projects
//                   </p>
//                 </motion.div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default ArchitectHero;
import banner from "./HERO2.png";
import React from 'react';
import { ArrowRight, Play, BookOpen, Users } from 'lucide-react';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import HeroImage from './HERO2.png';
import { useNavigate } from "react-router-dom";

const ArchitectHero = () => {
  const navigate = useNavigate()
  const [shapeIndex, setShapeIndex] = useState(0);
  
  // Tableau de différentes formes de blob modernes
  const shapes = [
    "rounded-[40%_60%_60%_40%_/_30%_30%_70%_70%]",
    "rounded-[60%_40%_30%_70%_/_60%_30%_70%_40%]",
    "rounded-[30%_70%_50%_50%_/_50%_15%_85%_50%]",
    "rounded-[45%_55%_70%_30%_/_40%_60%_40%_60%]",
    "rounded-[65%_35%_75%_25%_/_40%_60%_40%_60%]"
  ];

  // Rotation des formes toutes les 8 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setShapeIndex((prev) => (prev + 1) % shapes.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);
// Function to open Telegram link
const openTelegram = (link) => {
  window.open(link, "_blank"); // Opens in a new tab
};

// Function to open WhatsApp chat with a pre-filled message
const sendWhatsAppMessage = ( message) => {
  const url = `https://wa.me/213549075577?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

  // Variantes d'animation
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12
      }
    }
  };

  const imageVariants = {
    hidden: { scale: 0.8, opacity: 0, rotate: -5 },
    visible: {
      scale: 1,
      opacity: 1,
      rotate: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15,
        delay: 0.3
      }
    },
    pulse: {
      scale: [1, 1.02, 1],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const shapeVariants = {
    initial: { borderRadius: shapes[0] },
    animate: {
      borderRadius: shapes[shapeIndex],
      transition: {
        duration: 1.5,
        ease: "easeInOut"
      }
    }
  };

  const floatVariants = {
    float: {
      y: [0, -15, 0],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  return (
    <div>
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Image de fond avec animation */}
      <motion.div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: HeroImage ? `url(${HeroImage})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <motion.div 
          className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/60 to-transparent"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        />
      </motion.div>

      {/* Conteneur principal du contenu */}
      <div className="relative z-10 container mx-auto px-6 lg:px-12 xl:px-20">
        <motion.div 
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Colonne de gauche : Contenu textuel */}
          <div className="max-w-2xl">
            {/* Badge supérieur */}
            <motion.div 
              className="mb-6 inline-block"
              variants={itemVariants}
            >
              <motion.span 
                className="inline-flex items-center px-3 py-1.5 bg-white/10 backdrop-blur-sm rounded-full border border-white/20"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <motion.span 
                  className="w-1.5 h-1.5 bg-emerald-400 rounded-full mr-2"
                  animate={{ 
                    scale: [1, 1.2, 1],
                    opacity: [1, 0.7, 1]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                <span className="text-white font-medium text-xs">Nouveau groupe de cours débutant bientôt</span>
              </motion.span>
            </motion.div>

            {/* Titre principal */}
            <motion.h1 
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight"
              variants={itemVariants}
            >
              <motion.span 
                className="block text-emerald-400"
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.2, type: "spring" }}
              >
                Your Future
              </motion.span>
              <motion.span 
                className="text-white"
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3, type: "spring" }}
              >
Without Limits
              </motion.span>
            </motion.h1>

            {/* Sous-titre */}
            <motion.p 
              className="text-md md:text-lg text-gray-200 mb-8 max-w-2xl leading-relaxed"
              variants={itemVariants}
            >
              Plateforme complète d'apprentissage en Architecture & Design. Maîtrisez les logiciels professionnels avec nos formations expertes.
            </motion.p>

            {/* Points forts de la méthodologie d'enseignement */}
            <motion.div 
              className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8"
              variants={itemVariants}
            >
              <motion.div 
  onClick={() => sendWhatsAppMessage( "Bonjour, je veux une consultation gratuite.")}
  className="flex items-center space-x-3 p-3 bg-white/5 rounded-lg backdrop-blur-sm border border-white/10 cursor-pointer"
  whileHover={{ 
    scale: 1.02,
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderColor: 'rgba(52, 211, 153, 0.3)'
  }}
  transition={{ type: "spring", stiffness: 300 }}
>
  <BookOpen className="text-emerald-400 mt-0.5" size={20} />
  <div>
    <h3 className="text-white font-semibold text-sm">Consultation gratuite</h3>
  </div>
</motion.div>

<motion.div 
  onClick={() => sendWhatsAppMessage( "Bonjour, je veux demander un rendu pour mon projet.")}
  className="flex items-center space-x-3 p-3 bg-white/5 rounded-lg backdrop-blur-sm border border-white/10 cursor-pointer"
  whileHover={{ 
    scale: 1.02,
    backgroundColor: 'rgba(255,255,255,0.08)',
    borderColor: 'rgba(52, 211, 153, 0.3)'
  }}
  transition={{ type: "spring", stiffness: 300 }}
>
  <Users className="text-emerald-400 mt-0.5" size={20} />
  <div>
    <h3 className="text-white font-semibold text-sm">Demander un rendu pour votre projet</h3>
 </div>
</motion.div>

            </motion.div>

            {/* Boutons */}
            <motion.div 
              className="flex flex-wrap gap-3"
              variants={itemVariants}
            >
              <motion.button 
              onClick={() => navigate("/all-courses")}
                className="group bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-lg flex items-center transition-all duration-300 shadow-md shadow-emerald-600/30 text-sm"
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: "0 10px 25px rgba(5, 150, 105, 0.4)"
                }}
                whileTap={{ scale: 0.98 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <span>Commencez à Apprendre Aujourd'hui</span>
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
              </motion.button>

              <motion.button 
              onClick={() => openTelegram("https://t.me/+j7-ZTpiWYWllMGU0")}
                className="group bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold px-6 py-3 rounded-lg border border-white/20 flex items-center transition-all duration-300 text-sm"
                whileHover={{ 
                  scale: 1.05,
                  backgroundColor: 'rgba(255,255,255,0.2)'
                }}
                whileTap={{ scale: 0.98 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <Play className="mr-2 group-hover:scale-110 transition-transform" size={18} fill="white" />
                <span>Voir une Leçon Gratuite</span>
              </motion.button>
            </motion.div>
          </div>

          {/* Colonne de droite : Section d'image animée */}
          <motion.div 
            className="relative lg:flex items-center justify-center hidden"
            variants={imageVariants}
            animate={["visible", "pulse"]}
          >
            <div className="relative w-full max-w-lg">
              {/* Conteneur d'image principal avec forme animée */}
              <div className="relative z-20">
                <motion.div 
                  className="relative overflow-hidden shadow-2xl"
                  variants={shapeVariants}
                  initial="initial"
                  animate="animate"
                  style={{
                    boxShadow: "0 20px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(52, 211, 153, 0.1)"
                  }}
                >
                  {/* Image avec superposition sombre */}
                  <div 
                    className="w-full h-96 relative rounded-2xl overflow-hidden"
                    style={{
                      backgroundImage: `url('https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80')`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  >
                    {/* Superposition sombre avec dégradé */}
                    <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/30 to-black/50"></div>
                    <motion.div 
                      className="absolute inset-0 flex flex-col items-center justify-center text-center p-8"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.8 }}
                    >
                      <motion.div
                        variants={floatVariants}
                        animate="float"
                      >
                        <Users className="w-16 h-16 text-emerald-400 mx-auto mb-4" />
                      </motion.div>
                      <p className="text-white font-semibold text-lg">Étudiant en Architecture</p>
                      <motion.p 
                        className="text-emerald-200 text-sm mt-2"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 1 }}
                      >
                        Environnement d'apprentissage interactif
                      </motion.p>
                    </motion.div>
                  </div>
                </motion.div>

                {/* Éléments décoratifs animés */}
                <motion.div 
                  className="absolute -top-4 -right-4 w-24 h-24 bg-emerald-400/20 rounded-full blur-xl"
                  animate={{ 
                    scale: [1, 1.2, 1],
                    opacity: [0.3, 0.5, 0.3]
                  }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                <motion.div 
                  className="absolute -bottom-4 -left-4 w-32 h-32 bg-emerald-300/10 rounded-full blur-xl"
                  animate={{ 
                    scale: [1, 1.3, 1],
                    opacity: [0.2, 0.4, 0.2]
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1
                  }}
                />
              </div>

              {/* Carte de statistiques flottante */}
              <motion.div 
                className="absolute -bottom-6 -left-6 z-30 bg-gradient-to-br from-emerald-600 to-emerald-800 text-white p-4 rounded-xl shadow-2xl backdrop-blur-sm border border-emerald-400/30"
                variants={floatVariants}
                animate="float"
                whileHover={{ scale: 1.1, rotate: 2 }}
                transition={{ type: "spring" }}
              >
                <div className="text-center">
                  <motion.div 
                    className="text-2xl font-bold"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ 
                      type: "spring",
                      delay: 0.5,
                      stiffness: 200
                    }}
                  >
                    90%
                  </motion.div>
                  <div className="text-xs opacity-90">Taux de réussite</div>
                  <div className="text-[10px] opacity-75 mt-1">des étudiants trouvent un emploi</div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </motion.div>
      </div>



      {/* Indicateur de défilement animé */}
      <motion.div 
        className="absolute bottom-24 left-1/2 transform -translate-x-1/2 z-10"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5 }}
      >
        <div className="w-5 h-8 border-2 border-white/30 rounded-full flex justify-center">
          <motion.div 
            className="w-1 h-2 bg-white/60 rounded-full mt-1.5"
            animate={{ 
              y: [0, 6, 0]
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </div>
      </motion.div>

      {/* Éléments décoratifs animés */}
      <motion.div 
        className="absolute top-1/4 -left-20 w-96 h-96 bg-emerald-400/10 rounded-full mix-blend-overlay blur-3xl"
        animate={{ 
          x: [0, 50, 0],
          y: [0, -30, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <motion.div 
        className="absolute bottom-1/4 -right-20 w-96 h-96 bg-emerald-300/10 rounded-full mix-blend-overlay blur-3xl"
        animate={{  
          x: [0, -50, 0],
          y: [0, 30, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear",
          delay: 2
        }}
      />
    </section>
          {/* Bannière de statistiques en bas */}
      <motion.div 
        className=" left-0 right-0 bg-gradient-to-r from-emerald-900/90 via-emerald-800/90 to-emerald-900/90 backdrop-blur-lg border-t border-emerald-500/30 py-4 z-20"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8, ease: "easeOut" }}
      >
        <div className="container mx-auto px-6 lg:px-12 xl:px-20">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <motion.div 
                className="text-3xl md:text-4xl font-bold text-white mb-1"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 1, type: "spring" }}
              >
                25+
              </motion.div>
              <div className="text-emerald-200 text-sm md:text-base">Étudiants Formés</div>
            </div>
            <div className="text-center">
              <motion.div 
                className="text-3xl md:text-4xl font-bold text-white mb-1"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 1.2, type: "spring" }}
              >
                10+
              </motion.div>
              <div className="text-emerald-200 text-sm md:text-base">Projets Réalisés</div>
            </div>
            <div className="text-center">
              <motion.div 
                className="text-3xl md:text-4xl font-bold text-white mb-1"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 1.4, type: "spring" }}
              >
                90%
              </motion.div>
              <div className="text-emerald-200 text-sm md:text-base">Satisfaction</div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ArchitectHero;
